import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LeftCircleFilledSvg from "@ant-design/icons-svg/es/asn/LeftCircleFilled";
import AntdIcon from "../components/AntdIcon";
var LeftCircleFilled = function LeftCircleFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LeftCircleFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LeftCircleFilled.displayName = 'LeftCircleFilled';
}
export default /*#__PURE__*/React.forwardRef(LeftCircleFilled);